// extracted by mini-css-extract-plugin
module.exports = {"root":"Locations_root__1sNDu","edit_buttons":"Locations_edit_buttons__1F7kG","toolbar_button":"Locations_toolbar_button__KQK5M"};